import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAILURE,
  FIND_PRODUCT_INVENTORIES_REQUESTED,
  FIND_PRODUCT_INVENTORIES_SUCCESS,
  FIND_PRODUCT_INVENTORIES_FAILURE,
  DELETE_PRODUCT_METAFIELD_REQUESTED,
  DELETE_PRODUCT_METAFIELD_SUCCESS,
  UPDATE_SELECTED_ITEMS,
  SCAN_PRODUCT_REQUESTED,
  SCAN_PRODUCT_SUCCESS,
  SCAN_PRODUCT_FAILURE,
  ASSIGNMENTS_UPDATE_SUCCESS,
  RESET_PRODUCTS_STATE,
  ASSIGNMENT_CREATE_REQUESTED,
  ASSIGNMENT_CREATE_SUCCESS,
  ASSIGNMENTS_DELETE_REQUESTED,
  ASSIGNMENTS_DELETE_SUCCESS,
} from '../types';

const INITIAL_STATE = {
  activeProductInventoryDetails: null,
  searchedBrands: {},
  searchedProducts: null,
  searchedProductsPagination: null,
  searchedProductsMetafields: {},
  searchedVariations: null,
  searchedVariationsMetafields: {},
  isFetching: false,
  status: 'waiting',
  selectedProductList: { variations: {}, products: {} },
  errors: null,
  scanBackgroundColor: "primary20",
  scanMessage: "Scan barcodes to add items to this PO"
};

const products = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SEARCH_PRODUCT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        searchedBrands: {},
        searchedVariationsMetafields: {},
        searchedProductsMetafields: {},
        searchedProducts: null,
        searchedProductsPagination: null,
        searchedVariations: null,
      });

    case SEARCH_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        searchedProducts: action.payload.products,
        searchedVariationsMetafields: action.payload.variation_metafields,
        searchedProductsMetafields: action.payload.product_metafields,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case SEARCH_PRODUCT_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case ASSIGNMENTS_UPDATE_SUCCESS:
      // let body = {supplier_sku: action.response.supplier_sku, minimum_order: action.response.minimum_order, supplier_price: action.response.supplier_price}
      // let supplierKey = `Supplier-${action.response.supplier_id}`;

      if(action.response.variation_id) {
        if(newState.searchedVariationsMetafields && newState.searchedVariationsMetafields[action.assignmentId]) {
          let target = newState.searchedVariationsMetafields[action.assignmentId].find(metafield => metafield.supplier_id = action.response.supplier_id);
          if(target) {
            target.body = action.response;
          }
        }
      } else {
        if(newState.searchedProductsMetafields && newState.searchedProductsMetafields[parseInt(action.response.product_id)]) {
          let target = newState.searchedProductsMetafields[parseInt(action.response.product_id)].find(metafield => metafield.supplier_id = action.response.supplier_id);
          if(target) {
            target.body = action.response;
          }
        }
      }
      return newState;

    case UPDATE_SELECTED_ITEMS:
      return Object.assign({}, state, {
        selectedProductList: action.payload
      });

    case SCAN_PRODUCT_REQUESTED:
      return Object.assign({}, state, {
        scanBackgroundColor: "primary10",
        scanMessage: "Searching for barcode..."
      });

    case SCAN_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        scanBackgroundColor: "success20",
        scanMessage: "Barcode found"
      });

    case SCAN_PRODUCT_FAILURE:
      return Object.assign({}, state, {
        scanBackgroundColor: "danger20",
        scanMessage: (action.message || "Failed to load item")
      });

      // TODO: this should be done in the delete success, not in the request, but duplicating isn't happening correctly
    case ASSIGNMENTS_DELETE_REQUESTED:
      console.log(action);

      let toModify = null;
      if(action.variationId) {
        toModify = newState.searchedVariationsMetafields[`${action.productId}/${action.variationId}`]?.findIndex(metafield => action.supplierId === metafield.supplier_id)
        if(toModify) { delete newState.searchedVariationsMetafields[`${action.productId}/${action.variationId}`][toModify] };
      } else {
        toModify = newState.searchedProductsMetafields[action.productId]?.findIndex(metafield => action.supplierId === metafield.supplier_id);
        if(toModify) { delete newState.searchedProductsMetafields[action.productId][toModify] };
      }

      console.log(toModify);


      // toModify.body = {};
      
      return newState

    case ASSIGNMENTS_DELETE_SUCCESS:
      console.log(action);

      let toDelete = null;
      // if(action.response['data'].variation_id) {
      //   toDelete = newState.searchedVariationsMetafields[`${action.response['data'].product_id}/${action.response['data'].variation_id}`] = { data: [] }
      // } else {
      //   toDelete = newState.searchedProductsMetafields[action.response['data'].product_id] = { data: [] }
      // }

      return newState;

    case ASSIGNMENT_CREATE_REQUESTED:
    case ASSIGNMENT_CREATE_SUCCESS:
      // This could probably be better, not really duplicating correctly so no updates on success, but should be only on success, shouldn't eliminate so much stuff
      if(action.payload.assignmentValues.type === 'variation') {
        newState.searchedVariationsMetafields[`${action.payload.assignmentValues.productId}/${action.payload.assignmentValues.variationId}`] = [{
          body: {
            minimum_order: action.payload.assignmentValues.minimumQuantity,
            supplier_sku: action.payload.assignmentValues.supplierSku,
            supplier_price: action.payload.assignmentValues.supplierPrice,
          },
          supplier_id: action.payload.supplierId,
          type: 'supplier'
        }]
      }
      

      if(action.payload.assignmentValues.type === 'product') {
        newState.searchedProductsMetafields[`${action.payload.assignmentValues.productId}`] = [{
            body: {
              minimum_order: action.payload.assignmentValues.minimumQuantity,
              supplier_sku: action.payload.assignmentValues.supplierSku,
              supplier_price: action.payload.assignmentValues.supplierPrice,
            },
            supplier_id: action.payload.supplierId,
            type: 'supplier'
          }]
      }

      return newState;

    case FIND_PRODUCT_INVENTORIES_REQUESTED:
      newState.activeProductInventoryDetails = null;
      return newState;

    case FIND_PRODUCT_INVENTORIES_SUCCESS:
      newState.activeProductInventoryDetails = action.payload;
      return newState;

    case RESET_PRODUCTS_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default products;
